import React, { Component }            from 'react';
import { ClipLoader }                  from 'react-spinners';
import { Alert, Button, Modal,
         Accordion, Card }             from 'react-bootstrap';
import { MdAddCircle }                 from 'react-icons/md';
import { FaStar }                      from 'react-icons/fa';
import { withRouter }                  from 'react-router';
import { connect }                     from 'react-redux';
import PubSub                          from 'pubsub-js';
import AddItem                         from './AddItem';
import { EmployeeOnboardingConstants } from '../../environment';
import { isLoggedIn }                  from '../../../../../utils/authService';
import { isInRoleFromToken }           from '../../../../../utils/authService';
import { ticketsFetchData }            from '../../../../../actions/employee-onboarding/tickets';
import { addFetchData }                from '../../../../../actions/employee-onboarding/add';

var apiHost = EmployeeOnboardingConstants.WebApiHost;

class Add extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal : false,
      activeKey : 0
    };

    this.delete = this.delete.bind(this);
    this.open   = this.open.bind(this);
    this.close  = this.close.bind(this);
    
    this.handleSelect = this.handleSelect.bind(this);
  }
  
  subscriber(msg, data){
    if (data.SR) {
      this.delete(data.SR);
    }
  }
  
  handleSelect(evt, key) {
    PubSub.publish('employee.add.groups', null);
    this.props.fetchDataAdd(apiHost, null);
    //if (evt === true) {
      this.setState({ activeKey: key });
    //}
    //else {
    //  this.setState({ activeKey: 0 });
    //}
  }

  delete(id) {
    PubSub.publish('employee.add.groups', null);
    this.props.fetchDataTickets(apiHost);
    this.setState({showModal: false});
  }

  close() {
    PubSub.publish('employee.add.groups', null);
    this.props.fetchDataAdd(apiHost, null);
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  componentDidMount() {
    //this.props.fetchDataTickets(apiHost);
    this.token = PubSub.subscribe('employee.add.action', this.subscriber.bind(this));
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
  }
  
  render() {
    let add =
      <div>
        <div style={{marginBottom: '10px', marginLeft: '10px'}}>
          <button onClick={this.open}>
            <MdAddCircle size={24} />
          </button>
          <span> ( <FaStar color='yellow' style={{ stroke: 'black', strokeWidth: '2px' }} /> = new employee already in group ) </span>
        </div>
        <Modal animation={false} show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddItem action={this.close} />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>;

    let content = null;
    var items   = [];
    for (let i = 0; i < this.props.tickets.length; i++) {
      var item = this.props.tickets[i];
      let header = 
        <div>
          {item.id.toUpperCase()} -
          Requestor - {item.requestor ? item.requestor.toLowerCase() : 'unknown'}
        </div>;
      
      items.push(   
        <Accordion expanded={this.state.activeKey === (i+1) ? true : false} key={i}>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} onClick={(evt) => this.handleSelect(evt, i+1)} variant="link" eventKey={i}>
                {header}
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey={i}>
              <Card.Body>
                <AddItem item={item} key={item.id} />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>    
      );
    }
    
    if (isLoggedIn() && isInRoleFromToken(EmployeeOnboardingConstants.AdminRole)) {
      if (items.length > 0) {
        content =
          <div>
            {add}
            <Accordion id='add-group'>
              {items}
            </Accordion>
          </div>;
      }
      else if (!this.props.ticketsIsLoading) {
        content =
          <div> 
            {add}
            <Alert variant="warning">
              <strong>No Existing Requests</strong>
            </Alert>
          </div>;
      }
    }

    return (
      <div>
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          { this.props.ticketsIsLoading && isLoggedIn() && isInRoleFromToken(EmployeeOnboardingConstants.AdminRole) ?
            <ClipLoader
              color={'#072659'}
              loading={this.props.ticketsIsLoading}
            />
            : <span />
          }
        </div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    tickets: state.employee.tickets.tickets,
    ticketsHasErrored: state.employee.tickets.ticketsHasErrored,
    ticketsIsLoading: state.employee.tickets.ticketsIsLoading,
    add: state.employee.add.add,
    addHasErrored: state.employee.add.addHasErrored,
    addIsLoading: state.employee.add.addIsLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataTickets: (host) =>         dispatch(ticketsFetchData(host)),
    fetchDataAdd    : (host, params) => dispatch(addFetchData(host, params))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Add));
